import { cva, VariantProps } from 'class-variance-authority';
import { icons } from 'lucide-react';
import { HTMLAttributes } from 'react';
import DynamicIcon from 'src/shared/components/ui/icons/dynamic-icon';
import { Loading } from 'src/shared/components/ui/loaders/loading';

const alertVariants = cva('border px-4 py-2 flex items-center gap-4 text-sm', {
  variants: {
    variant: {
      alert: 'bg-slate-50 text-neutral-600',
      info: 'bg-sky-50 text-sky-700 border-sky-200',
      warning: 'bg-orange-50 text-orange-700 border-orange-200',
      error: 'bg-destructive-50 text-destructive-700 border-destructive-200',
      loading: 'bg-slate-50 text-neutral-600',
      success: 'bg-success-50 text-success-700 border-success-200',
    },
  },
  defaultVariants: {
    variant: 'alert',
  },
});

interface AlertProps extends VariantProps<typeof alertVariants>, Omit<HTMLAttributes<HTMLDivElement>, 'className'> {
  icon?: keyof typeof icons;
  title?: string;
  description: string;
}

export default function Alert({ icon, title, description, variant, ...props }: AlertProps) {
  return (
    <div className={alertVariants({ variant })} {...props}>
      {variant === 'loading' ? (
        <Loading size={22} />
      ) : (
        icon && <DynamicIcon name={icon} size={20} className="shrink-0" />
      )}
      <div>
        <p className="font-medium mb-0.5 capitalize">
          {title || variant}
          {variant === 'loading' ? '...' : '!'}
        </p>
        <p>{description}</p>
      </div>
    </div>
  );
}
